import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkbox", "field"]

  declare checkboxTarget: HTMLInputElement
  declare fieldTarget: HTMLElement

  connect() {
    this.toggle()
  }

  toggle() {
    if (this.checkboxTarget.checked) {
      this.fieldTarget.classList.add("hidden")
      // 無制限/無期限選択時は入力値をクリアし、サーバーにnullとして送信する
      this.fieldTarget.querySelectorAll("input").forEach((input) => {
        ;(input as HTMLInputElement).value = ""
      })
    } else {
      this.fieldTarget.classList.remove("hidden")
    }
  }
}
